<template>
  <div>
    <BasicModal
      :title="'一括送付'"
      :isShowModal="isShowModal"
      :canCancel="true"
      @cancel="cancel">
    <div class="bulk-action-container">
      <button class="button is-fullwidth is-primary"
        @click="clickBulkSendEmail">
        <span class="mdi mdi-email"></span>
        メール一括送付
      </button>
    </div>
    </BasicModal>
  </div>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'

export default {
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    clickBulkSendEmail () {
      this.$emit('cancel', false)
      this.$emit('clickBulkSendEmail', 'email')
    }    
  }
}
</script>

<style lang="scss" scoped>
.bulk-action-container {
  padding: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/DetailMail.vue